// extracted by mini-css-extract-plugin
export var grid = "ExperienceList-module--grid--xVtLy";
export var container = "ExperienceList-module--container--2r0CQ";
export var item = "ExperienceList-module--item--3vjBt";
export var jobTitle = "ExperienceList-module--jobTitle--DRbTZ";
export var logoContainer = "ExperienceList-module--logoContainer--3A8gG";
export var logo = "ExperienceList-module--logo--3NMeC";
export var companyName = "ExperienceList-module--companyName--1bOkC";
export var year = "ExperienceList-module--year--2YX5C";
export var show = "ExperienceList-module--show--1XtE3";
export var showFadeInDown = "ExperienceList-module--show-fade-in-down--Q-TwK";
export var showFadeInUp = "ExperienceList-module--show-fade-in-up--wlz76";
export var hideFadeOut = "ExperienceList-module--hide-fade-out--1rFdK";